import React, { useMemo } from "react";
import { FlexContainer, MutedDarkText, TinyText } from "shared/styles";

import { IContact } from "shared/types";
import { Phone } from "shared/components";

import { MainTeaser, TeaserProps } from "./MainTeaser";
import { Spacer } from "shared/layout";

interface ContactTeaserProps extends IContact, TeaserProps {
  note?: string;
}

export const ContactTeaser: React.FC<ContactTeaserProps> = ({
  firstname,
  lastname,
  company,
  jobTitle,
  phone,
  mobile,
  email,
  actions,
  onClick,
  disabled,
  note,
}) => {
  const title = useMemo(() => {
    const arr: string[] = [];
    if (lastname) arr.push(lastname);
    if (firstname) arr.push(firstname);
    return arr;
  }, [firstname, lastname]);

  const subTitle = useMemo(() => {
    const arr: string[] = [];
    if (company) arr.push(company);
    if (jobTitle) arr.push(jobTitle);
    return arr;
  }, [jobTitle, company]);

  return (
    <div>
      <MainTeaser
        title={title.join(" ")}
        subTitle={subTitle}
        actions={actions}
        data-testid="contact_teaser"
        onClick={onClick}
        disabled={disabled}
      >
        <Spacer size="xxs">
          <FlexContainer>
            {phone?.number && <Phone phone={phone} />}
            {phone?.number && mobile?.number && (
              <MutedDarkText> • </MutedDarkText>
            )}
            {mobile?.number && (
              <>
                <Phone phone={mobile} />{" "}
                <MutedDarkText as={TinyText}>(mobile)</MutedDarkText>
              </>
            )}
          </FlexContainer>
          <p>
            {email && (
              <a href={`mailto:${email}`} target="_blank" rel="noreferrer">
                {email}
              </a>
            )}
          </p>
          {note && <MutedDarkText>{note}</MutedDarkText>}
        </Spacer>
      </MainTeaser>
    </div>
  );
};
